import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Component({
  selector: 'app-biz-telegram',
  templateUrl: './biz-telegram.component.html',
  styleUrl: './biz-telegram.component.scss',
})
export class BizTelegramComponent implements OnInit {
  ngOnInit(): void {
    this.getBitTelegramRegisteration();
  }
  registeredBotToken?: string | null = null;
  registeredBotUsername?: string | null = null;

  isBotInfoLoading: boolean = false;
  isBotRegisterationError: boolean = false;
  isBotBeingEdited: boolean = false;

  telegramUserId?: string | null = null;
  telegramUserFullName?: string | null = null;
  telegramUsername?: string | null = null;

  isTelegramUserError: boolean = false;
  private registerationUUID: string = '';

  openRegistration() {
    window.open(
      `https://t.me/${this.registeredBotUsername}?start=reg-${this.registerationUUID}`,
      '_blank'
    );
    setTimeout(() => {
      this.getBitTelegramRegisteration();
    }, 10000);
  }

  constructor(private auth: AuthServiceService, private toast: ToastrService) {}

  candidateBotToken: string = '';

  getBitTelegramRegisteration() {
    this.isBotInfoLoading = true;
    this.auth.getBizTgBotRegistration().subscribe({
      next: (rv: any) => {
        this.isBotInfoLoading = false;

        if (!rv.ok) {
          this.isBotRegisterationError = true;
          this.toast.error(
            'Error while loading old bot token registeration. Please register again'
          );
          return;
        }
        this.registeredBotToken = rv.data.tgToken;
        this.registeredBotUsername = rv.bot.username;
        this.isTelegramUserError = rv.isUserError;
        if (!rv.isUserError && rv.telegramUser) {
          this.telegramUserId = rv.telegramUser.id + '';
          this.telegramUsername = rv.telegramUser.username;
          this.telegramUserFullName = `${rv.telegramUser.first_name ?? ' '} ${
            rv.telegramUser.last_name ?? ' '
          }`;
        }
        this.registerationUUID = rv.data.linkUUId;
      },
      error: (err) => {
        console.error(err);
        this.toast.error('Error while loading. pleast try again latter');
        this.isBotInfoLoading = false;
      },
    });
  }

  updateTelegramBotRegisteration() {
    this.auth.registerBizTgBot(this.candidateBotToken).subscribe({
      next: (rv: any) => {
        this.toast.show('Registeration successful!');
        //setTimeout(this.getBitTelegramRegisteration, 5000);
        this.getBitTelegramRegisteration();
        this.isBotBeingEdited = false;
      },
      error: (err) => {
        console.error(err);
        this.toast.error('Error while loading. pleast try again latter');
        //setTimeout(this.getBitTelegramRegisteration, 0);
        // this.getBitTelegramRegisteration();
        this.isBotBeingEdited = false;
      },
    });
  }
}
